//
// 定数
//
import CartypeAllImg from '@/assets/cartypes/all.jpg'
import Cartype5ninImg from '@/assets/cartypes/category_5nin.jpg'
import Cartype8ninImg from '@/assets/cartypes/category_8nin.jpg'
import Cartype10ninImg from '@/assets/cartypes/category_10nin.jpg'
import CartypeKJyouyouImg from '@/assets/cartypes/category_kjyouyou.jpg'
import CartypeKTokusyuImg from '@/assets/cartypes/category_ktokusyu.jpg'
import CartypeKTrackImg from '@/assets/cartypes/category_ktrack.jpg'
import CartypeTrackArumiImg from '@/assets/cartypes/category_trackarumi.jpg'
import CartypeTrackHiraImg from '@/assets/cartypes/category_trackhira.jpg'

//
// 標準オプションID
//
export const INCLUDE_ETC_ID = -23
export const INCLUDE_NAVI_ID = -22
export const INCLUDE_4WD_ID = -21
export const STUDLESS_ID = -14
export const PET_ID = -12
export const CHILDSEAT_ID = -11

//
// オプションの料金計算種別
//
export const PRICETYPE_DAY = 0
export const PRICETYPE_TIME = 1

//
// 送迎・配車サービスのメソッド
//
export const WAY_NONE = 0
export const WAY_START = 1
export const WAY_RETURN = 2
export const WAY_ROUND = 3

//
// 車両種別
//
export const cartypes = [{
  code: 'all',
  name: 'すべて',
  image: CartypeAllImg
},
{
  code: 'kjyouyou',
  name: '軽自動車',
  image: CartypeKJyouyouImg
},
{
  code: 'ktrack',
  name: '軽自動車\n軽トラック・軽バン',
  image: CartypeKTrackImg
},
{
  code: 'ktokusyu',
  name: '軽自動車特殊\nダンプ・介護',
  image: CartypeKTokusyuImg
},
{
  code: 'j5nin',
  name: '小型乗用車\n（5人乗り）',
  image: Cartype5ninImg
},
{
  code: 'j8nin',
  name: '普通乗用車\n（7～8人乗り）',
  image: Cartype8ninImg
},
{
  code: 'j10nin',
  name: 'ワゴンタイプ\n（10人乗り）',
  image: Cartype10ninImg
},
{
  code: 'trackhira',
  name: '小型トラック平ボディー\n1.25～2t',
  image: CartypeTrackHiraImg
},
{
  code: 'trackarumi',
  name: '小型トラック特殊\nアルミバン・パワーゲート・ダンプ',
  image: CartypeTrackArumiImg
},
{
  code: 'bus26',
  name: 'マイクロバス\n（26人乗り）',
  image: CartypeAllImg
},
{
  code: 'bus29',
  name: 'マイクロバス\n（29人乗り）',
  image: CartypeAllImg
}]

export const cartypeNames = {
  kjyouyou: '軽自動車',
  ktrack: '軽自動車 軽トラック・軽バン',
  ktokusyu: '軽自動車特殊 ダンプ・介護',
  j5nin: '小型乗用車（5人乗り）',
  j8nin: '普通乗用車 （7～8人乗り）',
  j10nin: 'ワゴンタイプ（10人乗り）',
  trackarumi: '小型トラック特殊 アルミバン・パワーゲート・ダンプ',
  trackhira: '小型トラック平ボディー 1.25～2t',
  bus26: 'マイクロバス（26人乗り）',
  bus29: 'マイクロバス（29人乗り）'
}

//
// 乗車定員
//
export const seats = [{
  code: 'all',
  name: '指定なし',
  first: 0,
  last: 999
},
{
  code: 's05',
  name: '1〜5名',
  first: 1,
  last: 5
},
{
  code: 's10',
  name: '6〜10名',
  first: 6,
  last: 10
},
{
  code: 's20',
  name: '20名以上',
  first: 20,
  last: 999
}]

//
// 空き状況の表示期間
//
export const TIMELINE_DAYS = 2 * 7 // 2 weeks

//
// 支払方法
//
export const PAY_SPOT = 'spot'
export const PAY_CARD = 'card'
